'use client';

import React from 'react';
import LegalDoc from '@/components/LegalDoc';
import { TERMS } from '@/lib/legal/documents';
import { useLanguage } from '@/contexts/LanguageContext';

export default function TermsPage() {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <LegalDoc
      title={isEs ? 'Términos del servicio' : 'Terms of service'}
      intro={
        isEs
          ? 'Esto es lo que acuerdas al usar Quantifyr, escrito para que se entienda a la primera.'
          : 'This is what you agree to by using Quantifyr, written to be understood on the first read.'
      }
    >
      <div className="space-y-9">
        {TERMS.map((section) => (
          <section key={section.heading.en}>
            <h2 className="font-display text-[18px] font-semibold tracking-tight text-ink">
              {isEs ? section.heading.es : section.heading.en}
            </h2>
            <div className="mt-3 space-y-3">
              {section.body.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-relaxed text-ink-soft">
                  {isEs ? p.es : p.en}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </LegalDoc>
  );
}
